import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
// import { useFormik } from "formik";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { toast } from "react-toastify";
import { retailerService } from "../../Services/retailerService";
import Loader from "../../Components/Loader";
import { PhoneCode } from "../../Components";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { customerServiceService } from "../../Services";
import csc from "country-state-city";
import helperFunction from "../../Function/helperFunction";

const retailerTypeList = [
  { value: "electronics", label: "Electronics" },
  { value: "home_furnishing", label: "Home Furnishing" },
  { value: "toy_store", label: "Toy Store" },
  { value: "carpet", label: "Carpet" },
  { value: "sports_goods", label: "Sports Goods" },
  { value: "e_commerce", label: "E Commerce" },
  { value: "department_stores", label: "Department Stores" },
  { value: "fashion", label: "Fashion" },
  { value: "footwear", label: "Footwear" },
  { value: "general", label: "General" },
];
const profitmarginTypeList = [
  { value: "freight", label: "Freight" },
  { value: "profitability_segment", label: "Profitability Segment" },
];

export const EditRetailer = () => {
  const [loader, setLoader] = useState(false);
  // eslint-disable-next-line
  const [newFieldList, setNewFieldList] = useState([]);
  const [togglePassword, setTogglePassword] = useState(false);
  const [retailerEmail, setRetailerEmail] = useState(false);
  const [country, setCountry] = useState(csc.getAllCountries());
  const [countryCode, setCountryCode] = useState("");
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [singledata, setSingledata] = useState([]);
  const history = useHistory();
  const data = history.location.state;
  let param = new URLSearchParams(history.location.search);
  const [customerServiceList, setCustomerServiceList] = useState([]);

  // incentive: "",
  // contact_person: "",
  // taxation_details: "",

  console.log(data, "ddddddddddddddddddddddddddddddddddddd")

  const initialValues = {
    retailer_name: data && data.retailer_name,
    referral_token: data && data.referral_token,
    retailer_type: data && data.retailer_type,
    type: data && data.type,
    
    ...(data?.type === "marketplace" && {
      profit_margin: data?.profit_margin || "retailer",
    }),
    phone_number: data && data.phone_number,
    retailer_email: data && data.retailer_email,
    vat_no: data && data.vat_no,
    total_discount: data && data.total_discount,
    customer_discount: data && data.customer_discount,
    store_discount: data && data.store_discount,
    designation: data && data.designation,
    sales_person: data && data.sales_person,
    contact_name: data && data.contact_name,
    address: data && data.address,
    region: data && data.region,
    country: data && data.country,
    state: data && data.state,
    city: data && data.city,
    postal_code: data && data.postalcode,
    retailer_password: "",
    store: [],
  };

  console.log(initialValues, "initialValues");

  const validationSchema = Yup.object().shape({
    retailer_name: Yup.string().required("Required"),
    retailer_password: Yup.string().min(8, "Minimum 8 Digit Password"),
    retailer_type: Yup.string().required("Required"),
    phone_number: Yup.string().required("Required"),
    retailer_email: Yup.string().required("Required"),
    contact_name: Yup.string().required("Required"),
    vat_no: Yup.string().required("Required").max(15, "Maximum 15 characters"),
    // total_discount: Yup.string().required("Required"),
    // customer_discount: Yup.string().required("Required"),
    // store_discount: Yup.string().required("Required"),
      // vat_no: Yup.string().when("type", {
      //     is: (type) => singledata[0]?.type === "marketplace",
      //     then: (schema) => schema.required("Vat no. is required").max(15, "Maximum 15 characters"),
      //     otherwise: (schema) => schema.notRequired(),
      //   }),
      total_discount: Yup.string().when("type", {
          is: (type) => singledata[0]?.type !== "marketplace",
          then: (schema) => schema.required("Total Discount is required"),
          otherwise: (schema) => schema.notRequired(),
        }),
        customer_discount: Yup.string().when("type", {
          is: (type) => singledata[0]?.type !== "marketplace",
          then: (schema) => schema.required("Customer Discount is required"),
          otherwise: (schema) => schema.notRequired(),
        }),
        store_discount: Yup.string().when("type", {
          is: (type) => singledata[0]?.type !== "marketplace",
          then: (schema) => schema.required("Store Discount is required"),
          otherwise: (schema) => schema.notRequired(),
        }),
    designation: Yup.string().required("Required"),
    region: Yup.string().required("Required"),
    referral_token: Yup.string()
      .required("Required")
      .min(3, "Minimum 3 Length referral code.")
      .max(7, "Maximum 7 Length referral code."),
    // .matches(
    //   /^(?=.*[A-Z])(?=.*[0-9])/,
    //   "Must Contain 4 Uppercase Latter And,Three Number "
    // ),
    store: Yup.array().of(
      Yup.object().shape({
        store_email: Yup.string().required("Required"),
        store_name: Yup.string().required("Required"),
        // store_password: Yup.string().required("Required"),
        contact_name: Yup.string().required("Required"),
        address: Yup.string().required("Required"),
        phone_number: Yup.string().required("Required"),
        store_designation: Yup.string().required("Required"),
      })
    ),
  });

  useEffect(() => {
    getItemList();
    // eslint-disable-next-line
  }, []);

  const getItemList = () => {
    let param = { role: "sales" };
    customerServiceService.getCustomerService(param).then((res) => {
      if (res.status) {
        let arr = [];
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].employee_name) {
            arr.push({
              ...res.data[i],
              value: res.data[i].employee_name,
              label: res.data[i].employee_name,
            });
          }
        }
        setCustomerServiceList(arr);
      }
    });
  };

  useEffect(() => {
    onDetail();
    // eslint-disable-next-line
  }, []);



  const onSubmit = (values) => {
    console.log(values, "values")
    setLoader(true);
    let postData = {
      //...fields,
      retailer_name: values.retailer_name,
      retailer_type: values.retailer_type,
      ...(values?.type === "marketplace" && {
        profit_margin: values?.profit_margin,
      }
    // ||
  ),
  total_discount: values.total_discount,
  customer_discount: values.customer_discount,
  store_discount: values.store_discount,
      phone_number: values.phone_number,
      retailer_email: values.retailer_email.toLowerCase(),
      contact_name: values.contact_name,
      sales_person: values.sales_person,
      vat_no: values.vat_no,
      designation: values.designation,
      address: values.address,
      region: values.region,
      country: values.country,
      state: values.state,
      city: values.city,
      postalcode: values.postal_code,
      store: values.store,
      referral_token: values.referral_token,
      id: param.get("id"),
    };
    if (values.retailer_password) {
      postData.retailer_password = values.retailer_password;
    }
    retailerService.updateRetailer(postData).then((res) => {
      console.log(res.data, "datatataat");
      if (res.status) {
        setLoader(false);
        history.push("/retailer-list");
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  const onDetail = () => {
    setLoader(true);
    let postData = {
      id: param.get("id"),
    };
    retailerService.getRetailerDetails(postData).then((res) => {
      if (res.status) {
        setLoader(false);
        getCountryStateCityLists(res?.data[0]);
        setSingledata(res.data);
        setNewFieldList({
          retailer_name: res.data.retailer_name,
          phone_number: res.data.phone_number,
          retailer_email: res.data.retailer_email,
          contact_name: res.data.contact_name,
          sales_person: res.data.sales_person,
          vat_no: res.data.vat_no,
          total_discount: res.data.total_discount,
          customer_discount: res.data.customer_discount,
          designation: res.data.designation,
          store_discount: res.data.store_discount,
          retailer_type: res.data.retailer_type,
          ...(res.data?.type === "marketplace" && {
            profit_margin: res.data?.profit_margin,
          }),

          store: res.data.store,
        });
        if (res.data[0].retailer_email) {
          setRetailerEmail(true);
        }
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  const onCountryChange = (e, name, setFieldValue) => {
    if (name === "country") {
      setStates(csc.getStatesOfCountry(e.isoCode));
      setCountryCode(e.isoCode);
    } else if (name === "state") {
      setCities(csc.getCitiesOfState(countryCode, e.isoCode));
    }
    setFieldValue([name], e.value);
  };

  const getCountryStateCityLists = (data) => {
    let countryData = country.find((itm) => itm.name === data.country);
    let allStates = csc.getStatesOfCountry(countryData?.isoCode);
    setStates(allStates);
    setCountryCode(countryData?.isoCode);
    let statesData = allStates.find((itm) => itm.name === data.state);
    setCities(csc.getCitiesOfState(countryData?.isoCode, statesData?.isoCode));
  };

  const onSelect = (e, values, setValues, name) => {
    setValues({
      ...values,
      [name]: e.value,
    });
    // console.log(values)
  };

  // const addStore = (errors, values, setValues) => {
  //   const store = [...values.store];

  //   const {
  //     retailer_type,
  //     retailer_name,
  //     retailer_email,
  //     phone_number,
  //     address,
  //     total_discount,
  //     customer_discount,
  //     incentive,
  //     contact_person,
  //     designation,
  //     store_discount,
  //     contact_name,
  //   } = values;

  //   if (errors && errors.store != undefined) {
  //     toast.error("fill initial Store data");
  //   } else {
  //     store.push({
  //       store_email: "",
  //       store_name: "",
  //       store_designation: "",
  //       contact_person: "",
  //       phone_number: "",
  //       address: "",
  //     });
  //     setValues({
  //       retailer_type,
  //       retailer_name,
  //       retailer_email,
  //       phone_number,
  //       address,
  //       total_discount,
  //       customer_discount,
  //       incentive,
  //       contact_person,
  //       designation,
  //       store_discount,
  //       contact_name,
  //       store,
  //     });
  //   }
  // };

  // const onClickRemove = (values, setValues) => {
  //   const store = [...values.store];
  //   store.pop();
  //   setValues({ ...values, store });
  // };

  const checkRefferalToken = async (reffToken) => {
    let result = await retailerService.checkRefferalTokenApiRetailer({
      referral_token: reffToken,
      retailer_id: param.get("id"),
    });
    if (result.status === true) {
      return "Already Exist";
    }
  };

  return (
    <div className="row d-flex justify-content-center">
      <div className="col-lg-8">
        <div className="card">
          <div className="card-body">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({
                errors,
                values,
                touched,
                setValues,
                setFieldError,
                setFieldValue,
                getFieldProps,
              }) => (
                (
                  <Form className="control-form">
                    <div className="row">
                  {/* Retailer type */}
                  <div className="mb-3 col-6">
                        <label className="form-label">
                        Retailer/Corporate/Markelplace Type
                        </label>
                        <Field
                        disabled
                          type="text"
                          value={singledata[0]?.type}
                          className={
                            "form-control" 
                            // + (touched.retailer_name && errors.retailer_name
                            //   ? " is-invalid"
                            //   : "")
                          }
                          // onChange={()=>handleInputChange()}
                          name="retailer_name"
                          placeholder="Enter Retailer Name"
                        />
                        {touched.retailer_name && errors.retailer_name ? (
                          <div className="text-danger">
                            {errors.retailer_name}
                          </div>
                        ) : null}
                      </div>
                      {/* Retailer Name */}
                      <div className="mb-3 col-6">
                        <label className="form-label">
                          Retailer/Corporate/Markelplace Name
                        </label>
                        <Field
                          type="text"
                          className={
                            "form-control" +
                            (touched.retailer_name && errors.retailer_name
                              ? " is-invalid"
                              : "")
                          }
                          // onChange={()=>handleInputChange()}
                          name="retailer_name"
                          placeholder="Enter Retailer Name"
                        />
                        {touched.retailer_name && errors.retailer_name ? (
                          <div className="text-danger">
                            {errors.retailer_name}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="row">
                      {/* Contact No. */}
                      <div className="mb-3 col-6">
                        <div className="form-group border">
                          <label className="form-label">Contact No.</label>
                          {/* <div className="input-group">
                          <Field
                            type="number"
                            className={
                              "form-control" +
                              (touched.phone_number && errors.phone_number
                                ? " is-invalid"
                                : "")
                            }
                            name="phone_number"
                            placeholder="Enter Contact Number"
                          />
                        </div> */}
                          <div
                            className={
                              touched.phone_number
                                ? !errors.phone_number
                                  ? " contact-success"
                                  : " contact-error"
                                : ""
                            }
                          >
                            <PhoneCode
                              Addphone={(value) =>
                                setValues({ ...values, phone_number: value })
                              }
                              phone={values.phone_number}
                            />
                          </div>
                        </div>
                        {touched.phone_number && errors.phone_number ? (
                          <div className="text-danger">
                            {errors.phone_number}
                          </div>
                        ) : null}
                      </div>
                      {/* Retailer Category */}
                      <div className="mb-3 col-6">
                        <label className="form-label">
                          Retailer/Corporate/Markelplace Category
                        </label>
                        <Select
                          styles={{
                            valueContainer: (provided) => ({
                              ...provided,
                              height: "calc(2.15rem + 2px)",
                              overflowY: "visible",
                            }),
                            control: (provider) => ({
                              ...provider,
                              borderColor: touched.retailer_type
                                ? !errors.retailer_type
                                  ? "#34c38f"
                                  : "#f46a6a"
                                : "#ced4da",
                              boxShadow: "0 0 0 0px #f46a6a",
                            }),
                            placeholder: (provider) => ({
                              ...provider,
                              color: "#a0b0ca",
                            }),
                          }}
                          name="retailer_type"
                          //  isOptionDisabled={(option) => option.isdisabled}
                          onChange={(e) =>
                            onSelect(e, values, setValues, "retailer_type")
                          }
                          options={retailerTypeList}
                          // eslint-disable-next-line
                          value={retailerTypeList.filter((val) => {
                            if (val.value === values.retailer_type) {
                              return val;
                            }
                          })}
                        />
                        {touched.retailer_type && errors.retailer_type ? (
                          <div className="text-danger">
                            {errors.retailer_type}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="row">
                      {/* address  */}
                      <div className="mb-3 col-6">
                        <label className="form-label">Address</label>
                        <Field
                          type="text"
                          className={
                            "form-control" +
                            (touched.address && errors.address
                              ? " is-invalid"
                              : "")
                          }
                          name="address"
                          placeholder="Enter Address"
                        />
                        {touched.address && errors.address ? (
                          <div className="text-danger">{errors.address}</div>
                        ) : null}
                      </div>
                      {/* country  */}
                      <div className="mb-3 col-3">
                        <label className="form-label">Country </label>
                        <Select
                          styles={{
                            valueContainer: (provided) => ({
                              ...provided,
                              height: "calc(2.15rem + 2px)",
                              overflowY: "visible",
                            }),
                            control: (provider) => ({
                              ...provider,
                              borderColor: touched.country
                                ? !errors.country
                                  ? "#34c38f"
                                  : "#f46a6a"
                                : "#ced4da",
                              boxShadow: "0 0 0 0px #f46a6a",
                            }),
                            placeholder: (provider) => ({
                              ...provider,
                              color: "#a0b0ca",
                            }),
                          }}
                          value={helperFunction
                            .convertToSelectList(country, "name", "name")
                            .find((itm) => itm.label === values.country)}
                          onChange={(e) =>
                            onCountryChange(e, "country", setFieldValue)
                          }
                          options={helperFunction.convertToSelectList(
                            country,
                            "name",
                            "name"
                          )}
                        />
                        {touched.country && errors.country ? (
                          <div className="text-danger">{errors.country}</div>
                        ) : null}
                      </div>
                      {/* state  */}
                      <div className="mb-3 col-3">
                        <label className="form-label">State </label>
                        <Select
                          styles={{
                            valueContainer: (provided) => ({
                              ...provided,
                              height: "calc(2.15rem + 2px)",
                              overflowY: "visible",
                            }),
                            control: (provider) => ({
                              ...provider,
                              borderColor: touched.state
                                ? !errors.state
                                  ? "#34c38f"
                                  : "#f46a6a"
                                : "#ced4da",
                              boxShadow: "0 0 0 0px #f46a6a",
                            }),
                            placeholder: (provider) => ({
                              ...provider,
                              color: "#a0b0ca",
                            }),
                          }}
                          onChange={(e) =>
                            onCountryChange(e, "state", setFieldValue)
                          }
                          value={helperFunction
                            .convertToSelectList(states, "name", "name")
                            .find((itm) => itm.label === values.state)}
                          options={helperFunction.convertToSelectList(
                            states,
                            "name",
                            "name"
                          )}
                        />
                        {touched.state && errors.state ? (
                          <div className="text-danger">{errors.state}</div>
                        ) : null}
                      </div>
                      
                      {/* W2D Sales Person */}
                      <div className="mb-3 col-6">
                        <label className="form-label">W2D Sales Person</label>
                        <Select
                          styles={{
                            valueContainer: (provided) => ({
                              ...provided,
                              height: "calc(2.15rem + 2px)",
                              overflowY: "visible",
                            }),
                            control: (provider) => ({
                              ...provider,
                              borderColor: touched.contact_name
                                ? !errors.contact_name
                                  ? "#34c38f"
                                  : "#f46a6a"
                                : "#ced4da",
                              boxShadow: "0 0 0 0px #f46a6a",
                            }),
                            placeholder: (provider) => ({
                              ...provider,
                              color: "#a0b0ca",
                            }),
                          }}
                          options={customerServiceList}
                          onChange={(e) =>
                            onSelect(e, values, setValues, "contact_name")
                          }
                          // to get value on referral change
                          // if (item?.employee_name === values?.contact_name) {
                          // return item;
                          // }
                          value={customerServiceList.find((item) => {
                            return item?.employee_name === values?.contact_name;
                          })}
                        />

                        {/* <label className="form-label">Contact Name</label>
                      <Field
                        type="text"
                        className={
                          "form-control" +
                          (touched.sales_person && errors.sales_person
                            ? " is-invalid"
                            : "")
                        }
                        name="sales_person"
                        placeholder="Enter Contact Name"
                      /> */}
                        {touched.sales_person && errors.sales_person ? (
                          <div className="text-danger">
                            {errors.sales_person}
                          </div>
                        ) : null}
                      </div>
                      {/* city  */}
                      <div className="mb-3 col-3">
                        <label className="form-label">City</label>
                        <Select
                          styles={{
                            valueContainer: (provided) => ({
                              ...provided,
                              height: "calc(2.15rem + 2px)",
                              overflowY: "visible",
                            }),
                            control: (provider) => ({
                              ...provider,
                              borderColor: touched.city
                                ? !errors.city
                                  ? "#34c38f"
                                  : "#f46a6a"
                                : "#ced4da",
                              boxShadow: "0 0 0 0px #f46a6a",
                            }),
                            placeholder: (provider) => ({
                              ...provider,
                              color: "#a0b0ca",
                            }),
                          }}
                          onChange={(e) => setFieldValue("city", e.value)}
                          value={helperFunction
                            .convertToSelectList(cities, "name", "name")
                            .find((itm) => itm.value === values.city)}
                          options={helperFunction.convertToSelectList(
                            cities,
                            "name",
                            "name"
                          )}
                        />
                        {touched.city && errors.city ? (
                          <div className="text-danger">{errors.city}</div>
                        ) : null}
                      </div>

                      {/* postal code  */}
                      <div className="mb-3 col-3">
                        <label className="form-label">Postal Code</label>
                        <Field
                          type="text"
                          className={
                            "form-control" +
                            (touched.postal_code && errors.postal_code
                              ? " is-invalid"
                              : "")
                          }
                          name="postal_code"
                          placeholder="Enter Postal Code"
                        />
                        {touched.postal_code && errors.postal_code ? (
                          <div className="text-danger">
                            {errors.postal_code}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* <div className="row"></div> */}
                    <div className="row">
                      {/* Email ID */}
                      <div className="mb-3 col-6">
                        <label className="form-label">Email ID</label>
                        <Field
                          type="email"
                          className={
                            "form-control" +
                            (touched.retailer_email && errors.retailer_email
                              ? " is-invalid"
                              : "")
                          }
                          name="retailer_email"
                          placeholder="Enter Email ID"
                          readOnly={(retailerEmail && true) || false}
                        />
                        {touched.retailer_email && errors.retailer_email ? (
                          <div className="text-danger">
                            {errors.retailer_email}
                          </div>
                        ) : null}
                      </div>
                      {/* Password */}
                      <div className="mb-3 col-6">
                        <label className="form-label"> Password</label>
                        <div className="d-flex">
                          <Field
                            type={togglePassword ? "text" : "password"}
                            className={
                              "form-control no-border-right no-border-left" +
                              (touched.retailer_password &&
                              errors.retailer_password
                                ? " is-invalid"
                                : "")
                            }
                            name="retailer_password"
                            placeholder="Enter Password"
                            autocomplete="new-password"
                          />
                          <button
                            type="button"
                            className="btn-primary"
                            onClick={() => setTogglePassword(!togglePassword)}
                          >
                            {togglePassword ? <FaEye /> : <FaEyeSlash />}
                          </button>

                          {/* <FaEye /> */}
                        </div>
                        {touched.retailer_password &&
                        errors.retailer_password ? (
                          <div className="text-danger">
                            {errors.retailer_password}
                          </div>
                        ) : null}
                      </div>
                    
                    </div>

                    

                    <div className="row">
                     {/* region  */}
                     <div className="mb-3 col-6">
                        <label className="form-label">REGION: LOCAL / OVERSEAS</label>
                        <Field
                          type="text"
                          className={
                            "form-control" +
                            (touched.region && errors.region
                              ? " is-invalid"
                              : "")
                          }
                          name="region"
                          placeholder="Enter Region"
                        />
                        {touched.region && errors.region ? (
                          <div className="text-danger">{errors.region}</div>
                        ) : null}
                      </div>
                      {/* Vat No. */}
                      <div className="mb-3 col-6">
                        <label className="form-label">VAT/TAX NUMBER: (ONLY FOR LOCAL PARTY)</label>
                        <Field
                          type="text"
                          className={
                            "form-control" +
                            (touched.vat_no && errors.vat_no
                              ? " is-invalid"
                              : "")
                          }
                          name="vat_no"
                          placeholder="Enter Vat No."
                        />
                        {touched.vat_no && errors.vat_no ? (
                          <div className="text-danger">{errors.vat_no}</div>
                        ) : null}
                      </div>
                    </div>

                    {/* {
                        singledata[0].type !
                      } */}
                    <div className="row">
                      {/* Designation */}
                      <div className="mb-3 col-6">
                        <label className="form-label">Designation</label>
                        <Field
                          type="text"
                          className={
                            "form-control" +
                            (touched.designation && errors.designation
                              ? " is-invalid"
                              : "")
                          }
                          name="designation"
                          placeholder="Enter Designation"
                        />
                        {touched.designation && errors.designation ? (
                          <div className="text-danger">
                            {errors.designation}
                          </div>
                        ) : null}
                      </div>

                      <div className="mb-3 col-6">
                        <label className="form-label">Sales Person</label>
                        <Field
                          type="text"
                          className={
                            "form-control" +
                            (touched.sales_person && errors.sales_person
                              ? " is-invalid"
                              : "")
                          }
                          name="sales_person"
                          placeholder="Enter Sales Person"
                        />
                        {touched.sales_person && errors.sales_person ? (
                          <div className="text-danger">
                            {errors.sales_person}
                          </div>
                        ) : null}
                      </div>
                      {/* REFERAL CODE */}
                      <div className="mb-3 col-6">
                        <label className="form-label">REFERAL CODE</label>
                        <Field
                          type="text"
                          className={
                            "form-control" +
                            (touched.referral_token && errors.referral_token
                              ? " is-invalid"
                              : "")
                          }
                          name="referral_token"
                          placeholder="Enter Referral Token"
                          validate={checkRefferalToken}
                        />
                        {touched.referral_token && errors.referral_token ? (
                          <div className="text-danger">
                            {errors.referral_token}
                          </div>
                        ) : null}
                      </div>

                     
                    </div>

                    {(singledata && singledata[0]?.type === "marketplace" && (
                      <div className="row">
                        <div className="mb-3 col-6">
                          <label className="form-label">Profit Margin</label>
                          <Select
                            styles={{
                              valueContainer: (provided) => ({
                                ...provided,
                                height: "calc(2.15rem + 2px)",
                                overflowY: "visible",
                              }),
                              control: (provider) => ({
                                ...provider,
                                borderColor: touched.profit_margin
                                  ? !errors.profit_margin
                                    ? "#34c38f"
                                    : "#f46a6a"
                                  : "#ced4da",
                                boxShadow: "0 0 0 0px #f46a6a",
                              }),
                              placeholder: (provider) => ({
                                ...provider,
                                color: "#a0b0ca",
                              }),
                            }}
                            name="profit_margin"
                            //  isOptionDisabled={(option) => option.isdisabled}
                            onChange={(e) =>
                              onSelect(e, values, setValues, "profit_margin")
                            }
                            options={profitmarginTypeList}
                            // eslint-disable-next-line
                            value={profitmarginTypeList.filter((val) => {
                              if (val.value === values.profit_margin) {
                                return val;
                              }
                            })}
                          />
                          {touched.profit_margin && errors.profit_margin ? (
                            <div className="text-danger">
                              {errors.profit_margin}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    )) || (
                      <div className="row">
                        {/* Total Discount */}
                        <div className="mb-3 col-4">
                          <label className="form-label">Total Discount</label>
                          <Field
                            type="number"
                            className={
                              "form-control" +
                              (touched.total_discount && errors.total_discount
                                ? " is-invalid"
                                : "")
                            }
                            name="total_discount"
                            placeholder="Enter Total Discount"
                          />
                          {touched.total_discount && errors.total_discount ? (
                            <div className="text-danger">
                              {errors.total_discount}
                            </div>
                          ) : null}
                        </div>
                        <div className="mb-3 col-4">
                          <label className="form-label">
                            Customer Discount
                          </label>
                          <Field
                            type="number"
                            className={
                              "form-control" +
                              (touched.customer_discount &&
                              errors.customer_discount
                                ? " is-invalid"
                                : "")
                            }
                            name="customer_discount"
                            placeholder="Enter Discount To Customer"
                          />
                          {touched.customer_discount &&
                          errors.customer_discount ? (
                            <div className="text-danger">
                              {errors.customer_discount}
                            </div>
                          ) : null}
                        </div>
                        <div className="mb-3 col-4">
                          <label className="form-label">Store Discount</label>
                          <Field
                            type="number"
                            className={
                              "form-control" +
                              (touched.store_discount && errors.store_discount
                                ? " is-invalid"
                                : "")
                            }
                            name="store_discount"
                            placeholder="Enter Discount To Customer"
                          />
                          {touched.store_discount && errors.store_discount ? (
                            <div className="text-danger">
                              {errors.store_discount}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    )}

                    {/* <div className="row">
                    <div className="mb-3 col-6">
                      <label className="form-label">Incentive</label>
                      <Field
                        type="number"
                        className={
                              "form-control" +
                              (touched.incentive
                                && errors.incentive
                                  ? " is-invalid"
                                  : ""
                                )
                            }
                        name="incentive"
                        placeholder="Enter Incentive"
                      />
                      {touched.incentive && errors.incentive ? (
                        <div className="text-danger">{errors.incentive}</div>
                      ) : null}
                    </div> */}
                    {/* </div> */}

                    {/* <FieldArray name="store">
                    {() =>
                      values.store.map((item, key) => {
                        const storeError =
                          (errors.store?.length && errors.store[key]) || {};

                        const storeTouched =
                          (touched.store?.length && touched.store[key]) || {};

                        return (
                          <div className="border p-2 my-2">
                            <div className="row">
                              <div className="mb-3 col-6">
                                <label className="form-label">Store Name</label>
                                <Field
                                  type="text"
                                  name={`store.${key}.store_name`}
                                  className={
                                    "form-control " +
                                    (storeError.store_name &&
                                    storeTouched.store_name
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={item.store_name}
                                  placeholder="Enter Name"
                                />
                              </div>
                              <div className="mb-3 col-6">
                                <div className="form-group">
                                  <label className="form-label">
                                    Contact No.
                                  </label>
                                  <div className="input-group">
                                    <Field
                                      type="number"
                                      className={
                                        "form-control" +
                                        (storeError.phone_number &&
                                        storeTouched.phone_number
                                          ? " is-invalid"
                                          : "")
                                      }
                                      name={`store.${key}.phone_number`}
                                      value={item.phone_number}
                                      placeholder="Enter Contact Number"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>


                            <div className="row">
                              <div className="mb-3 col-6">
                                <label className="form-label">
                                  Store Email{" "}
                                </label>
                                <Field
                                  type="email"
                                  className={
                                    "form-control" +
                                    (storeError.store_email &&
                                    storeTouched.store_email
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name={`store.${key}.store_email`}
                                  value={item.store_email}
                                  placeholder="Enter Email"
                                  // readOnly
                                />
                              </div>
                              <div className="mb-3 col-6">
                                <label className="form-label"> Address</label>
                                <Field
                                  type="text"
                                  className={
                                    "form-control" +
                                    (storeError.address && storeTouched.address
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name={`store.${key}.address`}
                                  value={item.address}
                                  placeholder="Enter Address"
                                />
                              </div>
                              <div className="mb-3 col-6">
                                <label className="form-label">
                                  Contact Person
                                </label>
                                <Field
                                  type="text"
                                  className={
                                    "form-control" +
                                    (storeError.contact_person &&
                                    storeTouched.contact_person
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name={`store.${key}.contact_person`}
                                  value={item.contact_person}
                                  placeholder="Enter Contact Name"
                                />
                              </div>
                              <div className="mb-3 col-6">
                                <label className="form-label">Designation</label>
                                <Field
                                  type="text"
                                  className={
                                    "form-control" +
                                    (storeError.store_designation &&
                                    storeTouched.store_designation
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name={`store.${key}.store_designation`}
                                  value={item.store_designation}
                                  placeholder="Enter Designation"
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })
                    }
                  </FieldArray>

                  <div className="d-flex justify-content-start">
                    {values.store.length >= 1 && (
                      <button
                        className="btn btn-sm btn-secondary me-2"
                        type="button"
                        onClick={() => onClickRemove(values, setValues)}
                      >
                        {" "}
                        - Remove
                      </button>
                    )}

                    <button
                      className="btn btn-sm btn-info"
                      type="button"
                      onClick={() => addStore(errors, values, setValues)}
                    >
                      {" "}
                      + Add Store Details
                    </button>
                  </div> */}

                    <div className="mt-3 d-flex justify-content-between">
                      <button
                        className="btn btn-danger w-sm waves-effect waves-light"
                        type="button"
                        onClick={() => history.goBack()}
                      >
                        Back
                      </button>
                      <button
                        className="btn btn-primary w-sm waves-effect waves-light"
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                  </Form>
                )
              )}
            </Formik>

            <Loader isShow={loader} />
          </div>
        </div>
      </div>
    </div>
  );
};
